import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dispatch_renderer = _resolveComponent("dispatch-renderer")!

  return (_ctx.control.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_dispatch_renderer, {
          visible: _ctx.control.visible,
          enabled: _ctx.control.enabled,
          schema: _ctx.control.schema,
          uischema: _ctx.detailUiSchema,
          path: _ctx.control.path,
          renderers: _ctx.control.renderers,
          cells: _ctx.control.cells,
          disableUpdateOpass: _ctx.disableUpdateOpass
        }, null, 8, ["visible", "enabled", "schema", "uischema", "path", "renderers", "cells", "disableUpdateOpass"])
      ]))
    : _createCommentVNode("", true)
}